import { render, staticRenderFns } from "./WhyChooseUsManage.vue?vue&type=template&id=653450f2&scoped=true&"
import script from "./WhyChooseUsManage.vue?vue&type=script&lang=ts&"
export * from "./WhyChooseUsManage.vue?vue&type=script&lang=ts&"
import style0 from "./WhyChooseUsManage.vue?vue&type=style&index=0&id=653450f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653450f2",
  null
  
)

export default component.exports